module.exports = __webpack_public_path__ + "static/img/3.8c20202.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/eng/3.png
// module id = coV6
// module chunks = 0